import { Icon, Media } from '@jd/platform-config/types';
import { DeepNullToUndefined } from '@jd/client/utils/unnulable';
import imgMapper from '../../../utils/mappers/image';
import { TBIcon } from './type';

type Input = DeepNullToUndefined<Icon>;

export const iconMapper = (input: Input | undefined): TBIcon | undefined => {
  if (!input) return;
  if (input.customIcon && typeof input.customIcon === 'object') {
    const image = imgMapper(input.customIcon as DeepNullToUndefined<Media>);
    if (!image) return;
    return { kind: 'custom', image };
  }
  if (input.muiIcon) {
    return {
      kind: 'mui',
      name: `${input.muiIcon}${input.muiIconType ? `_${input.muiIconType}` : ''}`,
    };
  }
  return;
};
